import { Company, COMPANY_TEMPLATE } from "./company";
import { DtacBase } from "./dtac-base";

export interface TransportMeans extends DtacBase {
  transportCompany: Company;
  vehicleRegistration: string;
}

export const TRANSPORT_MEANS_TEMPLATE: TransportMeans = {
  '@id': '',
  '@type': '',
  transportCompany: COMPANY_TEMPLATE,
  vehicleRegistration: ''
};
